export default __webpack_public_path__ + "static/media/DSC_0697.15a67ec7.JPG";